<template>
  <ui-modal-layout
    :title="tr('Change password')"
    :description="tr('Update your :app account password below. A strong password helps protect your account and personal information.')"
    :icon="KeyRoundIcon"
  >
    <form
      id="change-password-form"
      class="flex flex-col gap-4"
      novalidate
      @submit.prevent="() => submit()"
    >
      <div class="flex flex-col gap-1.5">
        <ui-label for="change-password-current">{{ tr('Current password') }}</ui-label>
        <password-field
          id="change-password-current"
          v-model="currentPassword"
          :placeholder="tr('Enter current password here')"
        />
      </div>
      <div class="flex flex-col gap-1.5">
        <ui-label for="change-password-new">{{ tr('New password') }}</ui-label>
        <password-field
          id="change-password-new"
          v-model="newPassword"
          autocomplete="new-password"
          :placeholder="tr('Enter new password here')"
        />
      </div>
    </form>

    <template #footer>
      <ui-button variant="outline" :disabled="isLoading" @click="() => $emit('close')">
        {{ tr('Cancel') }}
      </ui-button>
      <ui-button type="submit" form="change-password-form" :disabled="isLoading">
        <loader-circle-icon v-if="isLoading" class="animate-spin" />
        {{ tr('Change') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { KeyRound, LoaderCircle } from '@lucide/vue';
import { markRaw } from 'vue';

import AuthService from '@/services/Auth';
import PasswordField from '@/ui/components/PasswordField.vue';

export default {
  name: 'ChangePasswordModal',
  components: {
    LoaderCircleIcon: LoaderCircle,
    PasswordField,
  },
  data: () => ({
    KeyRoundIcon: markRaw(KeyRound),
    currentPassword: '',
    newPassword: '',
    isLoading: false,
  }),
  methods: {
    validate() {
      this.$toast.clear();

      if (!this.newPassword || !this.currentPassword) {
        this.$toast.error(this.tr('Password cannot be empty!'));
        return false;
      }

      if (this.newPassword.length < 8) {
        this.$toast.error(this.tr('The password must be at least 8 characters long.'));
        return false;
      }

      return true;
    },
    submit() {
      if (!this.validate()) {
        return;
      }

      this.isLoading = true;
      const data = {
        id: this.$root.loggedInUser.id,
        oldPassword: this.currentPassword,
        newPassword: this.newPassword,
      };
      AuthService.updatePassword(data)
        .then(resp => {
          this.$toast.success(this.tr('Password changed successfully!'));

          return resp;
        })
        .catch(err => this.error(err))
        .finally(() => {
          this.$fullscreenModal.closeAll();
          this.isLoading = false;
        });
    },
  },
};
</script>
